import Toggle from './Toggle';

export default Toggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-toggle/es/index.js
// module id = 30
// module chunks = 0